import type { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

/**
 * Module state
 */
interface State {
    caller:string;
    tasks:string;
}

const moduleState: State = {
    caller: localStorage.getItem('Base/caller')||'',
    tasks: localStorage.getItem('Base/tasks')||"[]"
};

/**
 * Module getters
 */
const moduleGetters: GetterTree<State, any> = {
    caller(state: State) {
        return state.caller || '';
    },
    tasks(state:State) {
        const tasks =  state.tasks || "[]";
        return JSON.parse(tasks);
    }
};

/**
 * Module mutations
 */
const moduleMutations: MutationTree<State> = {
    setCaller(state: State, caller: string) {
        console.log(caller);
        state.caller = caller;
    },
    setTasks(state: State, tasks: string[]) {

        state.tasks = JSON.stringify(tasks);
    },
};

/**
 * Module actions
 */
const moduleActions: ActionTree<State, any> = {

};

/**
 * Construct Module
 */
const module: Module<State, any> = {
    namespaced: true,
    state: moduleState,
    getters: moduleGetters,
    mutations: moduleMutations,
    actions: moduleActions,
};
export default module;
